module.exports = __webpack_public_path__ + "static/media/Gotham-Medium.2bb92423.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/Gotham-Medium.woff
 ** module id = 1343
 ** module chunks = 0
 **/